// =========================
// lib/waitlist.js  (BL-018b — Audience Capture)
//
// Public client for the durable waitlist. Unlike lib/admin, this sends NO
// Authorization header and never reads a Supabase session — landing-page
// visitors are anonymous. It POSTs to the public /waitlist-signup Netlify
// function, which writes to the service_role-only waitlist_signups table.
//
// Return-shape contract (mirrors lib/admin):
//   success → { data: responseBody, error: null }
//   failure → { data: null, error: { message } }   (never throws)
//
// The landing page uses this fire-and-forget on an optimistic submit: a
// failure here must never break the visitor's "you're on the list" experience.
//
// URL convention matches every other Netlify-function caller:
// ${API_BASE_URL}/<function-name> (api/* → /.netlify/functions/* via netlify.toml).
// =========================

import { API_BASE_URL } from '../services/api';

// BL-038 Story 38.1/38.3 — the body additionally carries an optional, NON-billing
// `planInterest` (which plan the visitor expressed interest in) and `attribution`
// (first-touch utm_* captured by lib/attribution). Both are spread in only when
// present so anonymous signups stay clean; the backend whitelists plan_interest
// to the canonical tiers and the utm_* keys it persists.
export async function joinWaitlist({ email, firstName, segment, source, planInterest, attribution } = {}) {
  try {
    const response = await fetch(`${API_BASE_URL}/waitlist-signup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        first_name: firstName || null,
        segment: segment || null,
        source: source || 'landing_v2',
        plan_interest: planInterest || null,
        ...(attribution && typeof attribution === 'object' ? attribution : {}),
      }),
    });
    const body = await response.json().catch(() => null);
    if (!response.ok || body?.success === false) {
      return {
        data: null,
        error: { message: body?.error || `HTTP ${response.status}` },
      };
    }
    return { data: body, error: null };
  } catch (err) {
    return { data: null, error: { message: err?.message || 'Network error.' } };
  }
}
